// hooks/useAuthHydrated.ts
import * as React from "react";
import { useAuthStore } from "../store/useAuthStore";

export function useAuthHydrated(): boolean {
  const [hydrated, setHydrated] = React.useState<boolean>(
    (useAuthStore as any).persist?.hasHydrated?.() ?? true
  );

  React.useEffect(() => {
    const persist = (useAuthStore as any).persist;
    if (!persist) return;

    if (persist.hasHydrated()) {
      setHydrated(true);
      return;
    }
    const unsub = persist.onFinishHydration?.(() => setHydrated(true));
    return () => unsub?.();
  }, []);

  return hydrated;
}
